module.exports = __webpack_public_path__ + "media/audio1.25d8002e.wav";